import { faLeftLong, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Dropdown, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteCartByJobId,
  DeleteProductByIdAPI,
  GetCartByJobId,
  GetCartsByUsersIdAPI,
  UpdateCartByJobId,
  UpdateProductByIdAPI,
} from "../service/AddCartJobs";
import { setAddedCartLength } from "../redux/feature/usersDataSIice";
import { toast } from "react-toastify";
import { setOpenTypeofSupply } from "../redux/feature/jobSlice";
import { SelectPopup } from "../components/SelectPopup";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export const AddedCartList = () => {
  // const [productDetails, setProductDetails] = useState("");
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);

  const [itemDtails, setItemDtails] = useState({
    id: "",
    productName: "",
    productPrice: "",
    typeofSupply: "",
    quantity: "",
    userId: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [totalPrice, SetTotalPrice] = useState("");

  const dispatch = useDispatch();
  const selectCategory = useSelector((state) => state.jobSlice.selectCategory);
  const customerUsersData = useSelector(
    (state) => state.auth.customerUsersData
  );
  const jobIdData = useSelector((state) => state.jobSlice.jobId);

  const onChangeFunc = useSelector((state) => state.jobSlice.onChangeFunc);
  const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
  const userRole = userInfo?.userRole;
  const handleGetCardByUserId = async () => {
    try {
      const response = await GetCartsByUsersIdAPI(
        // userInfo.userId ?? customerUsersData
        userRole === "CompanyUser" ? userInfo.userId : customerUsersData
      );

      SetTotalPrice(response?.data?.totalPrice);
      dispatch(setAddedCartLength(response?.data?.cartData?.length));
      // setProductDetails(response.data);
      setCartData(response?.data?.cartData || []);
    } catch (error) {
      setCartData([]);
      console.error("Error fetching cart data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetCartByJobId = async () => {
    if (jobIdData.id) {
      try {
        const response = await GetCartByJobId(jobIdData.id);

        SetTotalPrice(response?.data?.totalPrice);
        dispatch(setAddedCartLength(response?.data.cartData?.length));
        setCartData(response?.data.cartData || []);
      } catch (error) {
        setCartData([]);
        console.error("Error fetching cart data by job ID", error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  useEffect(() => {
    if (jobIdData.id) {
      handleGetCartByJobId();
    } else {
      handleGetCardByUserId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    jobIdData.id,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    userRole === "CompanyUser" ? userInfo.userId : customerUsersData,
  ]);
  // useEffect(() => {
  //   handleGetCardByUserId();
  //    eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userRole === "CompanyUser" ? userInfo.userId : customerUsersData]);

  const handleDeleteProduct = async (Id) => {
    try {
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (isConfirmed) {
        if (jobIdData.id) {
          const response = await DeleteCartByJobId(Id, jobIdData.id);
          if (response) {
            await handleGetCartByJobId();
            Swal.fire("Deleted!", response.message, "success");
          } else {
            Swal.fire("Error!", response.message, "error");
          }
        } else {
          const response = await DeleteProductByIdAPI(Id);
          if (response) {
            await handleGetCardByUserId();
            Swal.fire("Deleted!", response.message, "success");
          } else {
            Swal.fire("Error!", response.message, "error");
          }
        }
      }
    } catch (error) {
      toast.error("Error submitting form:", error);
    }
  };

  const saveproductDetails = useMemo(() => {
    console.log(cartData, "data9898");
    return cartData.map((item) => ({
      id: item.id,
      productName: item.productName,
      productPrice: item.productPrice,
      typeofSupply: item.typeOfSupply ?? item.typeofSupply,
      quantity: item.quantity,
      userId: item?.userId,
    }));
  }, [cartData]);

  useEffect(() => {
    if (saveproductDetails.length > 0) {
      const firstProduct = saveproductDetails[0];
      setItemDtails((prevDetails) => ({
        ...prevDetails,
        productName: firstProduct?.productName,
        productPrice: firstProduct.productPrice,
        typeofSupply: firstProduct.typeofSupply,
        quantity: firstProduct.quantity,
        userId: firstProduct?.userId,
        id: firstProduct.id,
      }));
    }
  }, [saveproductDetails]);

  const handleUpdateProduct = async (details) => {
    const productDetails = {
      id: details?.id,
      productName: details?.productName,
      productPrice: details?.productPrice,
      typeofSupply: selectCategory || details?.typeofSupply,
      quantity: details?.quantity,
      userId: details?.userId,
    };

    try {
      const response = await UpdateProductByIdAPI(productDetails);
      dispatch(setOpenTypeofSupply(false));
      if (response.status) {
        handleGetCardByUserId();
      }
    } catch (error) {
      console.log("error while update the product", error);
    }
  };
  // const handleUpdateProductByJobId = async (details) => {
  //   const productDetails = {
  //     id: details?.id,
  //     jobId: jobIdData.id,
  //     productName: details?.productName,
  //     productPrice: details?.productPrice,
  //     typeofSupply: selectCategory || details?.typeofSupply,
  //     quantity: details?.quantity,
  //     userId: details?.userId,
  //   };

  //   try {
  //     const response = await UpdateCartByJobId(productDetails, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     console.log(response, "dtaat");
  //     dispatch(setOpenTypeofSupply(false));
  //     if (response.status) {
  //       handleGetCartByJobId();
  //     }
  //   } catch (error) {
  //     console.log("error while update the product", error);
  //   }
  // };
  const handleUpdateProductByJobId = async (details) => {
    console.log(details.typeOfSupply, "dtaat989");
    const productDetails = {
      cartItem: {
        id: details?.id,
        jobId: jobIdData.id,
        productName: details?.productName,
        productPrice: details?.productPrice,
        typeOfSupply: details?.typeofSupply || details?.typeOfSupply,
        quantity: details?.quantity,
        userId: details?.userId,
      },
    };

    try {
      const response = await UpdateCartByJobId(productDetails);
      console.log(response, "data");
      dispatch(setOpenTypeofSupply(false));
      if (response && response.status) {
        handleGetCartByJobId();
      }
    } catch (error) {
      console.log("Error while updating the product", error);
    }
  };

  const handleDecrementItems = (item) => {
    console.log(item, "Cont");
    if (item.quantity > 1) {
      const updatedItem = { ...item, quantity: item.quantity - 1 };
      if (jobIdData.id) {
        handleUpdateProductByJobId(updatedItem);
      } else {
        handleUpdateProduct(updatedItem);
      }
    }
  };
  const handleIncrementItems = (item) => {
    console.log(item, "Cont");
    const updatedItem = { ...item, quantity: item.quantity + 1 };
    console.log(updatedItem, "updatedItem");
    if (jobIdData.id) {
      handleUpdateProductByJobId(updatedItem);
    } else {
      handleUpdateProduct(updatedItem);
    }
  };

  const openTypeofSupply = useSelector(
    (state) => state.jobSlice.openTypeofSupply
  );

  const handleTypeofSupplyId = (type, item) => {
    const updatedItem = { ...item, typeofSupply: type };
    if (jobIdData.id) {
      handleUpdateProductByJobId(updatedItem);
    } else {
      handleUpdateProduct(updatedItem);
    }
  };

  // const [selectedValue, setSelectedValue] = useState("");

  // const handleChange = (event, item) => {
  //   const value = event.target.value;
  //   setSelectedValue(value);

  //   const updatedItem = { ...item, typeofSupply: value };
  //   handleUpdateProduct(updatedItem);
  // };

  useEffect(() => {
    if (onChangeFunc) {
      handleUpdateProduct(itemDtails);
      console.log("itemDtailsdd", itemDtails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCategory, onChangeFunc]);
  console.log(cartData, "cardData");
  function handleCheckOut() {
    if (jobIdData?.id) {
      navigate("/EditJob/" + jobIdData?.id);
    } else {
      navigate("/CreateJob");
    }
  }
  console.log(cartData, "ProductData");
  return (
    <>
      {" "}
      <div className="d-flex justify-content-between">
        {" "}
        <div className="main_title mb-2"> Cart List</div>
        <div>
          <button
            className="btn btn-success mb-2"
            onClick={() => window.history.back()}
          >
            <FontAwesomeIcon icon={faLeftLong} /> Back
          </button>
        </div>
      </div>
      <div className="custom_form1 mb-4 position-relative">
        {isLoading ? (
          <p>Loading...</p>
        ) : cartData.length === 0 ? (
          <p>No items in the cart.</p>
        ) : (
          <div>
            <div>
              <Table striped className="table product_sec custom_new_table">
                <thead>
                  <tr>
                    <th className="w-50">Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total Price</th>
                    <th>Type of Supply</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {cartData.map((item) => (
                    <tr key={item.id}>
                      <td className="custom_img">{item.productName}</td>
                      <td> ${item.productPrice}</td>
                      <td>
                        {" "}
                        <div className="quantity">
                          <button onClick={() => handleDecrementItems(item)}>
                            -
                          </button>
                          <span className="mx-1">{item.quantity}</span>

                          <button onClick={() => handleIncrementItems(item)}>
                            +
                          </button>
                        </div>
                      </td>
                      <td>${(item.productPrice * item.quantity).toFixed(2)}</td>
                      <td>
                        <div>
                          <Dropdown>
                            <Dropdown.Toggle
                              id="dropdown-basic"
                              variant="success"
                            >
                              {item.typeofSupply || item.typeOfSupply}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                as="button"
                                value="Equipments"
                                onClick={() =>
                                  handleTypeofSupplyId("Equipments", item)
                                }
                              >
                                Equipments
                              </Dropdown.Item>
                              <Dropdown.Item
                                as="button"
                                value="Parts"
                                onClick={() =>
                                  handleTypeofSupplyId("Parts", item)
                                }
                              >
                                Parts
                              </Dropdown.Item>
                              <Dropdown.Item
                                as="button"
                                value="Permits"
                                onClick={() =>
                                  handleTypeofSupplyId("Permits", item)
                                }
                              >
                                Permits
                              </Dropdown.Item>
                              <Dropdown.Item
                                as="button"
                                value="Misc"
                                onClick={() =>
                                  handleTypeofSupplyId("Misc", item)
                                }
                              >
                                Misc
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                      <td>
                        <button
                          className="dele_btn"
                          onClick={() => handleDeleteProduct(item.id)}
                        >
                          {" "}
                          <FontAwesomeIcon icon={faTrash} className="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>
      <div className="custom_form1 mb-4 position-relative">
        <Table striped className="summery_sec">
          <tbody>
            <tr>
              <td>
                <b>Order Summery </b>
              </td>
            </tr>
            {cartData.map((item) => (
              <tr key={item.id}>
                <td className="custom_img">{item.productName}</td>
                <td colSpan={2} className="text-end">
                  ${item.productPrice * item.quantity}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <b>Total amount</b>
              </td>
              <td colSpan={2} className="text-end">
                <b> ${totalPrice}</b>
              </td>
            </tr>
          </tbody>
        </Table>
        <Button variant="success" onClick={handleCheckOut}>
          CheckOut
        </Button>
        {openTypeofSupply ? <SelectPopup /> : ""}
      </div>
      <></>
    </>
  );
};
